module.exports = __webpack_public_path__ + "media/newstyle/images/icon-americanas-cb91dc9efd1447b437f81848cdf6041b.svg";